import { withNavigationWatcher } from './contexts/navigation';
import {
  BusBangKiemTuanThuPage,
  BusDangKyXePage,
  BusDiemDonTraPage,
  BusLaiXePage,
  CauHinhXeBusPage,
  BusMonitoringPage,
  BusXePage,
  BusNhaXePage,
  CampaignsPage,
  CauHinhLoaiDichVuPage,
  CauHinhMaHocSinhPage,
  ChamSocKhachHangPage,
  ChiTieuTuyenSinhPage,
  CoSoPage,
  ConCBNVPage,
  DanhSachThiPage,
  DmChienDichPage, DmChienDichTrangThaiPage, DmHePage, DmTrangThaiHocSinhPage,
  EmailTemplatePage,
  FormPage, HocSinhPage, HocSinhProfilePage,
  HocSinhTheoLopPage, HocSinhThoiHocPage,
  HocSinhTongHopTrangThaiPage,
  HomePage,
  KetQuaThiPage,
  KhoiPage,
  KhoiHePage,
  KyThiMonThiPage,
  KyThiPage,
  LoaiGiayToPage, LopPage,
  MonThiPage,
  NguonBietToiPage,
  NhapDiemThiPage,
  PhanLopPage,
  PhanTuyenPage,
  PhongThiPage,
  PhuHuynhPage, PnLPage,
  SaleSetRegister,
  SaleSetRegisterDichVu,
  SendEmailDetailPage,
  SmsPage,
  ThangDiemPage,
  ThiSinhPage,
  ThongTinHocSinhPage,
  TongDaNopPage,
  TruongPage,
  TsPhuHuynhAdmStatusPage,
  MonAnChiTietPage,
  CaAnTruongPage,
  ThucDonPage,
  DanThuocPage,
  CauHinhEmailPage,
  SmsTemplatePage,
  SendSmsDetailPage,
  CauHinhSmsPage,
  UnitPage,
  MedicationPage,
  StudentLogPage,
  HealthProblemPage,
  StudentMedicalHistoryPage,
  StudentMedicalHistoryDetailPage,
  DotDuTuyenPage,
  TsTrangThaiHocSinhAutoPage,
  DmTrangThaiThiPage
} from './pages';
import EmailPage from './pages/email';
import SmsNewPage from './pages/sms_service/sms';

import FormRegisterResultPage from './pages/form-register-result/FormRegisterResultPage';
import HoSoSurveyPage from './pages/ho-so-survey';
import PhuHuynhProfilePage from './pages/phu-huynh-profile/PhuHuynhProfilePage';
import BusDiemDanhBaoCaoPage from './pages/bus/bao-cao';
import MauThuTuyenSinhPage from './pages/quan-ly-thi/mau-thu-tuyen-sinh';


const routes = [
  {
    path: '/truong',
    component: TruongPage,
  },
  {
    path: '/phu-huynh',
    component: PhuHuynhPage,
  },
  {
    path: '/phu-huynh/:id',
    component: PhuHuynhProfilePage,
  },
  {
    path: '/pnl',
    component: PnLPage,
  },
  {
    path: '/nguon_biet_toi',
    component: NguonBietToiPage,
  },
  {
    path: '/dot_du_tuyen',
    component: DotDuTuyenPage,
  },
  {
    path: '/loai_giay_to',
    component: LoaiGiayToPage,
  },
  {
    path: '/con_cbnv',
    component: ConCBNVPage,
  },
  {
    path: '/co_so',
    component: CoSoPage,
  },
  {
    path: '/home',
    component: HomePage,
  },
  {
    path: '/lop',
    component: LopPage,
  },
  {
    path: '/phanlop',
    component: PhanLopPage,
  },
  {
    path: '/ds_hoc_sinh_lop',
    component: HocSinhTheoLopPage,
  },
  {
    path: '/ds_thoihoc',
    component: HocSinhThoiHocPage,
  },
  {
    path: '/danh_sach_hoc_sinh',
    component: ThongTinHocSinhPage,
  },
  {
    path: '/hoc-sinh',
    component: HocSinhPage,
  },
  {
    path: '/hoc-sinh/:id',
    component: HocSinhProfilePage,
  },
  // {
  //   path: '/cham_soc_khach_hang',
  //   component: ChamSocKhachHangPage,
  // },
  {
    path: '/campaigns',
    component: CampaignsPage,
  },
  {
    path: '/dm_chiendich',
    component: DmChienDichPage,
  },
  {
    path: '/chi_tieu_tuyen_sinh',
    component: ChiTieuTuyenSinhPage,
  },
  {
    path: '/trangthai_chiendich',
    component: DmChienDichTrangThaiPage,
  },
  {
    path: '/he',
    component: DmHePage,
  },
  {
    path: '/khoi',
    component: KhoiPage,
  },
  {
    path: '/khoi_he',
    component: KhoiHePage,
  },
  {
    path: '/form',
    component: FormPage,
  },
  {
    path: '/form-result',
    component: FormRegisterResultPage,
  },
  {
    path: '/ho-so',
    component: HoSoSurveyPage,
  },
  {
    path: '/cskh',
    component: ChamSocKhachHangPage,
  },
  {
    path: '/dm_trangthaihocsinh',
    component: DmTrangThaiHocSinhPage,
  },
  {
    path: '/sms',
    component: SmsPage,
  },
  {
    path: '/tong-hop-trang-thai',
    component: HocSinhTongHopTrangThaiPage,
  },
  {
    path: '/bus/dang-ky-xe',
    component: BusDangKyXePage,
  },
  {
    path: '/bus/xe',
    component: BusXePage,
  },
  {
    path: '/bus/nha-xe',
    component: BusNhaXePage,
  },
  {
    path: '/mon-thi',
    component: MonThiPage,
  },
  {
    path: '/ky-thi',
    component: KyThiPage,
  },
  {
    path: '/kythi-monthi',
    component: KyThiMonThiPage,
  },
  {
    path: '/thi-sinh',
    component: ThiSinhPage
  },
  {
    path: '/danh-sach-thi',
    component: DanhSachThiPage
  },
  {
    path: '/nhap-diem-thi',
    component: NhapDiemThiPage
  },
  {
    path: '/phong-thi',
    component: PhongThiPage
  },
  {
    path: '/ket-qua-thi',
    component: KetQuaThiPage
  },
  {
    path: '/bus/dang-ky-xe',
    component: BusDangKyXePage,
  },
  {
    path: '/bus/xe',
    component: BusXePage,
  },
  {
    path: '/bus/lai-xe',
    component: BusLaiXePage,
  },
  {
    path: '/bus/cau-hinh-xe-bus',
    component: CauHinhXeBusPage,
  },
  {
    path: '/bus/diem-don-tra',
    component: BusDiemDonTraPage,
  },
  {
    path: '/bus/monitoring',
    component: BusMonitoringPage,
  },
  {
    path: '/thang-diem',
    component: ThangDiemPage
  }
  ,
  {
    path: '/bus/phan-tuyen',
    component: PhanTuyenPage
  },
  {
    path: '/bus/bao-cao-diem-danh',
    component: BusDiemDanhBaoCaoPage
  },
  {
    path: '/cauhinh-mahocsinh',
    component: CauHinhMaHocSinhPage
  },
  {
    path: '/sf-saleset-register-dichvu',
    component: SaleSetRegisterDichVu
  },
  {
    path: '/saleset-register',
    component: SaleSetRegister
  }
  ,
  {
    path: '/cauhinh-loaidichvu',
    component: CauHinhLoaiDichVuPage
  },
  {
    path: '/bus/bang-kiem-tuan-thu',
    component: BusBangKiemTuanThuPage,
  },
  {
    path: '/tong-da-nop',
    component: TongDaNopPage,
  }
  ,
  {
    path: '/ts_phuhuynh_adm_status',
    component: TsPhuHuynhAdmStatusPage
  },
  {
    path: '/email-template',
    component: EmailTemplatePage
  },
  {
    path: '/send-email-detail/:emailTemplateIdParam',
    component: SendEmailDetailPage
  },
  {
    path: '/email',
    component: EmailPage
  },
  {
    path: '/food/monan-chitiet',
    component: MonAnChiTietPage
  },
  {
    path: '/food/ca-an-truong',
    component: CaAnTruongPage
  },
  {
    path: '/food/thucdon',
    component: ThucDonPage
  }
  ,
  {
    path: '/dan-thuoc',
    component: DanThuocPage
  },
  {
    path: '/dm-cauhinh-email',
    component: CauHinhEmailPage
  },
  {
    path: '/sms-new',
    component: SmsNewPage
  },
  {
    path: '/dm-cauhinh-sms',
    component: CauHinhSmsPage
  },
  {
    path: '/sms-template',
    component: SmsTemplatePage
  },
  {
    path: '/send-sms-detail/:smsTemplateIdParam',
    component: SendSmsDetailPage
  },
  {
    path: '/unit',
    component: UnitPage,
  },
  {
    path: '/medication',
    component: MedicationPage,
  },
  {
    path: '/health-problem',
    component: HealthProblemPage,
  },
  {
    path: '/student-log',
    component: StudentLogPage,
  },
  {
    path: '/student-medical-history',
    component: StudentMedicalHistoryPage,
  },
  {
    path: '/student-medical-history/:id',
    component: StudentMedicalHistoryDetailPage,
  },
  {
    path: '/mauthu-ketqua',
    component: MauThuTuyenSinhPage,
  },
  {
    path: '/ts_trangthaihocsinh_auto',
    component: TsTrangThaiHocSinhAutoPage,
  },
  {
    path: '/trang-thai-thi-sinh',
    component: DmTrangThaiThiPage,
  },
];

export default routes.map((route) => {
  return {
    ...route,
    component: withNavigationWatcher(route.component),
  };
});
